import React from "react";
import { useField } from "formik";

const DateInput = ({ label, shouldShowError, ...props }) => {
    const [field, meta] = useField(props);

    return (
        <div className="form-group col" {...props}>
            <label htmlFor={props.id || props.name}>{label}</label>
            <input
                type="date"
                name="endDate"
                max={props?.max}
                min={props?.min}
                className="form-control"
                {...field}
            />
            {shouldShowError || (meta.touched && meta.error) ? (
                <div className="text-danger">{meta.error}</div>
            ) : null}
        </div>
    );
};

export default DateInput;